import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  buttonStyle: {
    position: 'fixed',
    right: '25px',
    top: '25px',
    zIndex: '10000'
  },
  iconStyle: {
    fontSize: '2rem',
    color: props => (props.iconColor ? props.iconColor : `${theme.palette.black}A6`)
  }
}));

const ButtonCloseMaximize = ({ handleClose, iconColor }) => {
  const classes = useStyles({ iconColor });
  return (
    <IconButton aria-label="close" className={classes.buttonStyle} onClick={handleClose}>
      <CloseIcon className={classes.iconStyle} />
    </IconButton>
  );
};

ButtonCloseMaximize.propTypes = {
  handleClose: PropTypes.func.isRequired,
  iconColor: PropTypes.string
};

ButtonCloseMaximize.defaultProps = {
  iconColor: null
};

export default ButtonCloseMaximize;
